<p-dialog
  [(visible)]="display"
  [styleClass]="'error-dialog-root ' + (cssClass() || '')"
  [modal]="true"
  [header]="model?.summary"
  [minHeight]="'50px'"
  [responsive]="true"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  [style]="{ width: '80vw', 'max-width': '1100px' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }">
  <p *ngIf="model?.errorStatus">Status: {{ model?.errorStatus }}</p>
  <p [innerHTML]="model?.detail"></p>

  <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" class="btn btn-primary" pButton icon="pi pi-times" (click)="display = false">Cancel</button>
    </div>
  </ng-template>
</p-dialog>
